import { render, staticRenderFns } from "./SubmitRound.vue?vue&type=template&id=c2c2e870&scoped=true&"
import script from "./SubmitRound.vue?vue&type=script&lang=js&"
export * from "./SubmitRound.vue?vue&type=script&lang=js&"
import style0 from "./SubmitRound.vue?vue&type=style&index=0&id=c2c2e870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c2e870",
  null
  
)

export default component.exports